import { getRouteApi } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'

const rootApi = getRouteApi('__root__')
const appApi = getRouteApi('/_app')

/**
 * The signed-in viewer, off the options `__root` declares on its context and warms in its loader.
 *
 * These three exist because ~60 components read session/global chrome, and each would otherwise repeat
 * the `getRouteApi` + read: the hook IS the context access, not a wrapper around a parameter. Everything
 * else is declared on the route that needs it and read straight from `Route.useRouteContext()`.
 */
export function useSessionUser() {
  return useSessionUserQuery().data
}

/**
 * The same read, but the WHOLE query result — for the handful of call sites that must know whether
 * `getUser` is settled, not just what it currently holds. The global post-write revalidation keeps an
 * active query's data while it refetches, so `data` alone can be a pre-write snapshot for one round
 * trip; anything that REDIRECTS off the user's flags has to wait out `isFetching` first (see
 * register/applicant). Prefer `useSessionUser` when you only render the value.
 */
export function useSessionUserQuery() {
  return useSuspenseQuery(rootApi.useRouteContext().sessionUserQueryOptions)
}

/** Same, for the viewer's employee profile — declared and warmed by the `_app` layout. */
export function useMyEmployeeProfile() {
  return useSuspenseQuery(appApi.useRouteContext().myEmployeeProfileQueryOptions).data
}

/** Same, for the scroll-transition flag the route-transition surface picks its engine from. */
export function useScrollTransitionsEnabled() {
  return useSuspenseQuery(appApi.useRouteContext().scrollTransitionsEnabledQueryOptions).data
}
